import { render, staticRenderFns } from "./TaxForm.vue?vue&type=template&id=97601c0a&"
import script from "./TaxForm.vue?vue&type=script&lang=ts&"
export * from "./TaxForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports